import {createSlice} from "@reduxjs/toolkit";

const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  product: undefined,
  conversion: undefined,
  lastError: null,
  companyProductForEdit: null,
  brands: [],
  categories: [],
  languages: []
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const adminProductsSlice = createSlice({
  name: "products",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findproducts
    productsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
     // findproducts
     productFetched: (state, action) => {
      const { product, conversion } = action.payload;
      state.product = product;
      state.conversion = conversion;
    },
    // companyProductFetched
    companyProductFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyProductForEdit = action.payload.companyProductForEdit;
      state.brands = action.payload.brands;
      state.categories = action.payload.categories;
      state.languages = action.payload.languages;
      state.error = null;
    },
  }
});
